/** imported components
 
  * AssessmentPlantView ===> view file of assessment component.
  * assessment.scss for ===> styling css file for this page.
  * serviceProvider for ===> working with api
  * useState, useEffect ===> React hooks (useState is a way to get/set value)

**/

import React, { useState, useEffect } from "react";
import { useHistory, Link, Redirect } from "react-router-dom";
import { AssessmentPlantView } from "./assessmentplant-view";
import "./assessment.scss";
import serviceProvider from '../../services/axios'
//Assessment Component start
export const AssessmentPlantController = (props) => {
	 const getLastItem = (thePath) => thePath.substring(thePath.lastIndexOf("/") + 1);
	 const slug = getLastItem(window.location.pathname);
	
	//  const 
	//  console.log("tid--",tid)
	const [results, setResults] = useState([]);
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	
	const search = async () => {
			const apiUrl = `/assessmentmaturity?param=section&slug=${slug}&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl, true, {});
			setResults(data);
	};
	
	useEffect(() => {
		search();
	}, []);
	

if (results.length) {
		
		
	
			if(results[0].is_completed == 1 || results[0].block == 'block'){
						var pp = "/not-found";
				        return <Redirect to="/not-found" />;
						return (
								<>
									<div></div>
								</>
						);
			}else{ 
					
					return <AssessmentPlantView getAssessmentDetails={search} sectionData={results} {...props} />;
			}
			
			
	}else{
		return (
		<>
			<div></div>
		</>
	);
		
		}
    
	
	
	
	
};
